export enum Team {
  BizTeam = 'Biz Team',
}

export enum Feature {
  TeamlessCollaborationPrompt = 'Teamless Collaboration Prompt',
  TeamTemplatePicker = 'Team Template Picker',
  TeamProfile = 'Team Profile Header',
  TeamEditAvatar = 'Team Edit Avatar',
}
